import { Assign, ChevronDown, MoreOutline, Options } from '@doist/icons/product-ui';
import { Divider, Image, Stack } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIAvatar } from '../product-ui-avatar/product-ui-avatar';
import { ProductUIAvatarStack } from '../product-ui-avatar/product-ui-avatar-stack';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { ProductUIContextMenu, ProductUIContextMenuHeading } from '../product-ui-context-menu/product-ui-context-menu';
import { ProductUIIconButton } from '../product-ui-icon-button/product-ui-icon-button';
import { ProductUIPermissionListItem } from '../product-ui-list-item/product-ui-list-item';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function AdvancedPermissionsScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="AdvancedPermissionsScene" data-sentry-source-file="advanced-permissions.tsx">
            <ProductUISceneLayer position="bottomLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="advanced-permissions.tsx">
                <ProductUIAppWindow inlineSize={800} showSidebar sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView>
                                <ProductUIView.Header title={t('sequence.advancedPermissions.newBrand')} contextMenu={<ContextMenu />} actions={<>
                                            <ProductUIButton hovered={true} variant="quinary" startIcon={<Assign />}>
                                                {t('share')}
                                            </ProductUIButton>
                                            <ProductUIButton variant="quinary" startIcon={<Options />}>
                                                {t('view.view')}
                                            </ProductUIButton>
                                            <ProductUIIconButton icon={<MoreOutline />} />
                                        </>} />
                                <ProductUIView.Section>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="60" />
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="80" />
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        <ProductUISkeletonText width="40" />
                                    </ProductUITask>
                                    <Divider />
                                </ProductUIView.Section>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="advanced-permissions.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
function ContextMenu() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUIContextMenu placement={{
    top: 48,
    right: 48
  }} width={397} data-sentry-element="ProductUIContextMenu" data-sentry-component="ContextMenu" data-sentry-source-file="advanced-permissions.tsx">
            <ProductUIContextMenuHeading data-sentry-element="ProductUIContextMenuHeading" data-sentry-source-file="advanced-permissions.tsx">
                {t('sequence.advancedPermissions.access')}
            </ProductUIContextMenuHeading>

            <Stack gap="4" data-sentry-element="Stack" data-sentry-source-file="advanced-permissions.tsx">
                <ProductUIPermissionListItem avatar={<Image src="https://res.cloudinary.com/imagist/image/upload/v1718886737/doist-avatar_r2hdya.png" width={36} height={36} alt="" />} name={t('sequence.advancedPermissions.everyoneInTeam')} nameSize="minor-sm" skeletonWidth="20" abstracted={true} buttonSection={<ProductUIButton variant="quinary" endIcon={<ChevronDown />} />} data-sentry-element="ProductUIPermissionListItem" data-sentry-source-file="advanced-permissions.tsx" />
                <Divider data-sentry-element="Divider" data-sentry-source-file="advanced-permissions.tsx" />
            </Stack>

            <ProductUIContextMenuHeading data-sentry-element="ProductUIContextMenuHeading" data-sentry-source-file="advanced-permissions.tsx">
                {t('sequence.advancedPermissions.inThisProject')}
            </ProductUIContextMenuHeading>

            <Stack gap="4" data-sentry-element="Stack" data-sentry-source-file="advanced-permissions.tsx">
                <ProductUIPermissionListItem name={t('you')} avatar={<ProductUIAvatar size={36} character="denise" />} skeletonWidth="60" buttonSection={<ProductUIButton variant="quinary">
                            {t('sequence.advancedPermissions.leave')}
                        </ProductUIButton>} data-sentry-element="ProductUIPermissionListItem" data-sentry-source-file="advanced-permissions.tsx" />
                <Divider data-sentry-element="Divider" data-sentry-source-file="advanced-permissions.tsx" />
                <ProductUIPermissionListItem name={t('sequence.advancedPermissions.sharedWith', {
        count: 6
      })} avatar={<ProductUIAvatarStack>
                            <ProductUIAvatar size={36} character="ana" />
                            <ProductUIAvatar size={36} character="luis" />
                            <ProductUIAvatar size={36} character="stijn" />
                        </ProductUIAvatarStack>} buttonSection={<ProductUIButton variant="quinary">
                            {t('sequence.advancedPermissions.viewAll')}
                        </ProductUIButton>} data-sentry-element="ProductUIPermissionListItem" data-sentry-source-file="advanced-permissions.tsx" />
            </Stack>
        </ProductUIContextMenu>;
}
export { AdvancedPermissionsScene };